import { CardSection } from "~/components/atoms/CardSection";
import { Props as StastisticsBoxProps, StatisticsBox } from "~/components/molecules/StatisticsBox";
import { Testable } from "~/lib/testing";
import { Skeleton } from "~/components/atoms/Skeleton";

interface Props extends StastisticsBoxProps, Testable {
    title: string;
    subtitle?: string;
}

const StatisticsSectionContainer = ({
    title,
    subtitle,
    children,
    ...props
}: Pick<Props, "title" | "subtitle" | "data-testid"> & React.PropsWithChildren) => (
    <CardSection title={title} subtitle={subtitle} data-testid={props["data-testid"]}>
        <div className="px-6 sm:px-14">{children}</div>
    </CardSection>
);

export const StatisticsSectionLoading = ({ title }: Pick<Props, "title">) => (
    <StatisticsSectionContainer title={title}>
        <Skeleton className="h-[230px]" />
    </StatisticsSectionContainer>
);

export const StatisticsSectionError = ({ title }: Pick<Props, "title">) => (
    <StatisticsSectionContainer title={title}>
        <div className="text-center text-error-90">
            Error loading program {title.toLowerCase()} information.
        </div>
    </StatisticsSectionContainer>
);

export function StatisticsSection({ title, subtitle, asset, items, ...props }: Props) {
    const box = StatisticsBox({ asset, items });
    if (box === null) return null;
    return (
        <StatisticsSectionContainer
            title={title}
            subtitle={subtitle}
            data-testid={props["data-testid"]}
        >
            {box}
        </StatisticsSectionContainer>
    );
}
